// BooleanSelect.js
import { formatDataTest } from '@/common/dataTest/DataTest';
import { useInDialog } from '@/common/dialog/DialogScopeContext';
import { far } from '@awesome.me/kit-b4fd369ea4/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material';
import { useFormFieldDef } from '../hooks/useFormFieldDef';

export const BooleanSelect = ({ fieldDef }) => {
  const { value, setValue, onBlur, error, helperText, label, disabled } = useFormFieldDef(fieldDef);
  const inDialog = useInDialog();

  return (
    <FormControl error={error} disabled={disabled} data-test-id={formatDataTest(inDialog ? 'dialog' : 'main', 'form-field', fieldDef.displayName)}>
      <InputLabel>{label}</InputLabel>
      <Select
        value={value ?? ''} // Adjust default as needed for a boolean select
        onChange={(event) => setValue(event.target.value)}
        onBlur={onBlur}
      >
        <MenuItem value={true}>
          <FontAwesomeIcon icon={far.faCheck} color="green" aria-hidden="true" />
        </MenuItem>
        <MenuItem value={false}>
          <FontAwesomeIcon icon={far.faTimes} color="red" aria-hidden="true" />
        </MenuItem>
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};
